export * from './steps';
export * from './messageTypes';

export const invalidPasswordCharactersHex = [
  '0x60',
  '0x3E',
  '0x3C',
  '0x27',
  '0x1F',
  '0x1E',
  '0x1D',
  '0x1C',
  '0x1B',
  '0x1A',
  '0x19',
  '0x18',
  '0x17',
  '0x16',
  '0x15',
  '0x14',
  '0x13',
  '0x12',
  '0x11',
  '0x10',
  '0x0F',
  '0x0E',
  '0x0D',
  '0x0C',
  '0x0B',
  '0x0A',
  '0x09',
  '0x08',
  '0x07',
  '0x06',
  '0x05',
  '0x04',
  '0x03',
  '0x02',
  '0x01',
];
